import { z } from "zod";
import { VALIDATION_MESSAGES } from "../content/validation-messages";

const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
const optionalText = (max: number) => z.string().trim().max(max).nullable().optional();
const profileUrl = z
  .url({ protocol: /^https?$/, error: VALIDATION_MESSAGES.urlFormat })
  .max(500)
  .nullable()
  .optional();

export const AUTHOR_BIO_MAX_LENGTH = 5000;

export const authorInputSchema = z.object({
  slug: z.string().trim().min(3).max(160).regex(SLUG_PATTERN, VALIDATION_MESSAGES.slugFormat),
  name: z.string().trim().min(2).max(120),
  headline: optionalText(160),
  bio: optionalText(AUTHOR_BIO_MAX_LENGTH),
  avatarKey: optionalText(500),
  websiteUrl: profileUrl,
  youtubeUrl: profileUrl,
  instagramUrl: profileUrl,
  xUrl: profileUrl,
  linkedinUrl: profileUrl,
});
export type AuthorInput = z.infer<typeof authorInputSchema>;
